import React, { useCallback, useEffect, useState, FC } from 'react';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { ChevronDown } from 'react-bootstrap-icons';

import { reduxActions, useDispatch } from 'store';
import { Link } from 'components/controls';

import { useGetPanelNavigationDefinition } from 'plugins/api/endpoints/useGetPanelNavigationDefinition';
import { IDynamicCategory } from 'plugins/api/types';

import styles from 'theme/components/layouts/ManagmentPanelLayout/components/DashboardMenu.module.scss';

// typ danych wejściowych
interface IProps {
  isAdminPanel?: boolean;
}

const DashboardMenu: FC<IProps> = () => {
  const dispatch = useDispatch();

  // ścieżka z url
  const { pathname } = useLocation();

  const { data: menu } = useGetPanelNavigationDefinition();

  // lista (indeksów tablicy) rozwiniętych bloków w menu
  const [openedParentItemIndexes, setOpenedParentItemIndexes] = useState<number[]>([]);

  useEffect(() => {
    const blockItemIndex = menu?.navigation_definition.categories.findIndex((menuItem) =>
      menuItem.items?.some((subItem) =>
        isCurrentPath(subItem.component_name || subItem.dynamic_page)
      )
    );

    if (blockItemIndex) {
      setOpenedParentItemIndexes((prevState) => [...prevState, blockItemIndex]);
    }
  }, [pathname, menu]);

  // funkcja testujacy czy podana ścieżka jest aktualną stroną
  const isCurrentPath = useCallback(
    (testedPath: string) => pathname.includes(testedPath),
    [pathname]
  );

  // rozwinięcie/zwinięcie bloku w mwnu
  const toggleItem = (index: number) => {
    setOpenedParentItemIndexes((prevState) =>
      openedParentItemIndexes.includes(index)
        ? prevState.filter((item) => item !== index)
        : [...prevState, index]
    );
  };

  const renderParentItems = (parentItem: IDynamicCategory, index: number) => {
    return (
      <div className={styles.menuItem} key={index}>
        {!parentItem.items ? (
          <Link
            to="/managment_panel"
            onClick={() => dispatch(reduxActions.setIsMobileMenu(false))}
            className={classnames(styles.link)}>
            <>
              <div className={styles.iconWrapper}>
                <i className={`bi bi-${parentItem.icon}`}></i>
              </div>
              {parentItem.name}
            </>
          </Link>
        ) : (
          <div
            className={classnames(styles.label, {
              [styles.open]: openedParentItemIndexes.includes(index)
            })}
            onClick={() => toggleItem(index)}>
            <div className={styles.iconWrapper}>
              <i className={`bi bi-${parentItem.icon}`}></i>
            </div>
            {parentItem.name}
            <ChevronDown className={styles.arrow} />
          </div>
        )}

        {openedParentItemIndexes.includes(index) && (
          <div className={styles.subItemsWrapper}>
            {(parentItem.items || []).map((subItem, subItemIndex) => (
              <Link
                key={subItemIndex}
                to={
                  subItem.component_name
                    ? `/managment_panel/cms/${subItem.component_name}`
                    : `/managment_panel/dynamic_page/${subItem.dynamic_page}`
                }
                onClick={() => {
                  dispatch(reduxActions.setIsMobileMenu(false));
                }}
                className={classnames(styles.subItem, {
                  [styles.current]: isCurrentPath(subItem.component_name || subItem.dynamic_page)
                })}>
                {subItem.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Containers-DashboardMenu')}>
      {menu?.navigation_definition.categories.map((parentItem, index) =>
        renderParentItems(parentItem, index)
      )}
    </div>
  );
};

export default DashboardMenu;
